// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Sibling imports
const linkModalActions = require('./actions')
const LinkModal = require('./component-dumb')

function mapStateToProps(state) {
  const { isLinkModalDismissed } = state.linkModal
  return {
    isLinkModalDismissed
  }
}

const mapDispatchToProps = {
  onLinkModalDismiss: linkModalActions.dismiss
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    LinkModal
  )
)
